<div class="slide-item-comp">
  <!-- [ngClass]="{ selected: selected$ | async }" -->
  <ng-container *ngIf="!newSceneMode">
    <div
      class="preview"
      [class.selected]="isSelected"
      (click)="click()"
      (mouseover)="onMouseOver()"
      (mouseout)="onMouseOut()"
    >
      <img
        [src]="getThumbnailDataUrl()"
        alt=""
        style="width: 100%; height: 100%; object-fit: contain"
        [style.visibility]="!imgError && imgLoaded ? 'visible' : 'hidden'"
        (load)="imgLoaded = true; imgError = false"
        (error)="imgError = true; imgLoaded = false"
      />
      <div
        class="icon-container flex-row gap-2 position-absolute"
        [style.top.px]="6"
        [style.right.px]="6"
      >
        <nw-icon
          type="close"
          [outlined]="true"
          [size]="12"
          (click)="$event.stopPropagation(); onDelete()"
          matTooltip="Delete scene"
        ></nw-icon>
      </div>
    </div>
    <!-- <nw-editable-text
      [text]="slide?.literals?.label || 'Untitled Slide'"
      (textChanged)="updateLabel($event)"
      [inputWidth]="120"
    ></nw-editable-text> -->
  </ng-container>

  <div
    *ngIf="newSceneMode"
    class="preview flex-row space-around"
    (click)="click()"
  >
    <nw-icon type="add"></nw-icon>
  </div>
</div>
